import { render, staticRenderFns } from "./_PrivateMedicalInsurance.vue?vue&type=template&id=23fb4a21&"
import script from "./_PrivateMedicalInsurance.vue?vue&type=script&lang=js&"
export * from "./_PrivateMedicalInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports